import { useGraphqlQuery } from "@bsm/component"
import { TBankInformation } from "@bsm/graphql"
import { BankQuery } from "../queries/BankQuery"

export const useBankQuery = (id?: number, suspense?: boolean) => {
    return useGraphqlQuery<BankQuery, TBankInformation>(new BankQuery({ id }), { enabled: id !== undefined, suspense })
}
